export type Rasgo = {
  title: string
  key: string
  componente_genetico: string
  referencia?: string
  label: string
}

export const RASGOS: Rasgo[] = [
  {
    title: 'Tartamudez: ser tartamudo/a',
    key: 'tartamudez',
    referencia:
      'Fagnani, C., Fibiger, S., Skytthe, A., & Hjelmborg, J. V. (2011). Heritability and environmental effects for self-reported periods with stuttering: a twin study from Denmark. Logopedics Phoniatrics Vocology, 36(3), 114-120.',
    componente_genetico: 'Se midió hasta un 83%',
    label: 'Tartamudez',
  },
  {
    title: 'Zurdera: ser zurdo/a',
    key: 'zurdera',
    referencia:
      'Mitchell, K. J. (2020). Innate: How the wiring of our brains shapes who we are. Princeton University Press. Ver Capítulo 4.',
    componente_genetico: '25%',
    label: 'Zurdera',
  },
  {
    title: 'Esquizofrenia',
    key: 'esquizofrenia',
    referencia:
      'Plomin, R., DeFries, J. C., & Knopik, V. S. (2013). Behavioral Genetics. Ver Capítulo 14.',
    componente_genetico: '50%',
    label: 'Esquizofrenia',
  },
  {
    title: 'Autismo',
    key: 'autismo',
    referencia:
      'Plomin, R., DeFries, J. C., & Knopik, V. S. (2013). Behavioral Genetics. Ver Capítulo 16.',
    componente_genetico: '80%',
    label: 'Autismo',
  },
  {
    title: 'Depresión',
    key: 'depresión',
    componente_genetico: 'De 37% a 48%',
    referencia:
      'Corfield, E. C., Yang, Y., Martin, N. G., & Nyholt, D. R. (2017). A continuum of genetic liability for minor and major depression. Translational psychiatry, 7(5), e1131-e1131.',
    label: 'Depresión',
  },
  {
    title: 'Indice de masa corporal: relación entre peso y altura',
    key: 'imc',
    componente_genetico: 'De 40% a 80%',
    referencia:
      'Feng, R. (2016). How much do we know about the heritability of BMI?. Plomin, R., DeFries, J. C., & Knopik, V. S. (2013). Behavioral Genetics. Ver Capítulo 19.',
    label: 'Indice de masa corporal',
  },
  {
    title: 'Fluencia verbal: facilidad para el tuti fruti',
    key: 'fluencia_verbal',
    componente_genetico: 'De 30% a 58%',
    referencia:
      'Plomin, R., DeFries, J. C., & Knopik, V. S. (2013). Behavioral Genetics. Ver Capítulo 13.',
    label: 'Fluencia verbal',
  },
  {
    title: 'Visualización espacial: habilidad para encajar piezas mentalmente',
    key: 'visualización_espacial',
    componente_genetico: 'De 46% a 71%',
    referencia:
      'Plomin, R., DeFries, J. C., & Knopik, V. S. (2013). Behavioral Genetics. Ver Capítulo 13.',
    label: 'Visualización espacial',
  },
  {
    title:
      'Facilidad para la velocidad perceptual: cuán rápido apretás un botón cuando se prende una luz',
    key: 'velocidad_perceptual',
    componente_genetico: 'De 46% a 58%',
    referencia:
      'Plomin, R., DeFries, J. C., & Knopik, V. S. (2013). Behavioral Genetics. Ver Capítulo 13.',
    label: 'Velocidad perceptual',
  },
  {
    title: 'Extroversión',
    key: 'extroversión',
    componente_genetico: '37%',
    referencia:
      'Vukasović, T., & Bratko, D. (2015). Heritability of personality: a meta-analysis of behavior genetic studies. Psychological bulletin, 141(4), 769.',
    label: 'Extroversión',
  },
  {
    title: 'Neuroticismo: inestabilidad emocional',
    key: 'neuroticismo',
    componente_genetico: '36%',
    referencia:
      'Vukasović, T., & Bratko, D. (2015). Heritability of personality: a meta-analysis of behavior genetic studies. Psychological bulletin, 141(4), 769.',
    label: 'Neuroticismo',
  },
]
